import ModalRenderer from '@commons/enhanced-modal/ModalRenderer'
import EnhancedPopIn from './EnhancedPopIn'
import { ModalProvider } from '@commons/enhanced-modal/ModalContext'
import { PBProps } from './types'
import { getPBProps } from '@content/helpers/src/utils'

const EnhancedPopInWrapper = ({ data }) => {
    const pbProps = getPBProps<PBProps>(data)
    const {
        copywriting: {
            promotion_details,
            open,
            autoCloseTime,
            autoOpenTime,
            openOnUserInactivity,
            autoOpenOnUserLeaving
        },
        campaign
    } = pbProps as PBProps

    return (
        <ModalProvider defaultOpen={autoOpenTime ? false : open}>
            <ModalRenderer
                promotion_details={promotion_details}
                campaign={campaign}
                isSubComponent={false}
            />
            <EnhancedPopIn
                autoCloseTime={autoCloseTime}
                autoOpenTime={autoOpenTime}
                openOnUserInactivity={openOnUserInactivity}
                autoOpenOnUserLeaving={autoOpenOnUserLeaving}
            />
        </ModalProvider>
    )
}

export default EnhancedPopInWrapper
